import { Search } from 'lucide-react';
import type { InputHTMLAttributes } from 'react';
import { cn } from '../ui/utils';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'className' | 'type'> & {
  className?: string;
  inputClassName?: string;
};

/**
 * Search row with icon + text in one flex row (no absolute positioning) so the
 * magnifier and placeholder stay vertically aligned inside #tailwind-root.
 */
export function MessageHubSearchField({ className, inputClassName, ...props }: Props) {
  return (
    <div
      className={cn(
        'flex h-10 w-full min-w-0 items-center gap-2 rounded-xl border border-slate-200 bg-slate-50 px-3 shadow-sm transition focus-within:border-green-500 focus-within:ring-2 focus-within:ring-green-500/25',
        className
      )}
    >
      <Search
        className="pointer-events-none h-[18px] w-[18px] shrink-0 text-slate-400"
        strokeWidth={2}
        aria-hidden
      />
      <input
        type="search"
        autoComplete="off"
        spellCheck={false}
        className={cn(
          'min-h-0 min-w-0 flex-1 border-0 bg-transparent p-0 text-sm leading-5 text-slate-900 shadow-none outline-none ring-0 placeholder:text-slate-400 focus:ring-0',
          inputClassName
        )}
        {...props}
      />
    </div>
  );
}
